export default "__VITE_ASSET__i9xym91h__"